var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _mask, _mask2, _mask3, _mask4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleTagManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "24.691233%",
    x2: "74.733562%",
    y1: "26.424697%",
    y2: "80.126865%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0.02
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "24.155126%",
    x2: "76.173587%",
    y1: "24.15507%",
    y2: "76.17353%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "41.172212%",
    x2: "58.443682%",
    xlinkHref: "#c",
    y1: "30.969402%",
    y2: "47.661406%"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "41.172212%",
    x2: "63.154537%",
    xlinkHref: "#c",
    y1: "30.969402%",
    y2: "52.181347%"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250.874183 115.639875-110.514058-110.51405847c-6.834422-6.83442204-17.885828-6.83442204-24.72025 0l-110.51405847 110.51405847c-6.83442204 6.834422-6.83442204 17.885828 0 24.72025l110.51405847 110.514058c6.834422 6.834423 17.885828 6.834423 24.72025 0l110.514058-110.514058c6.834423-6.834422 6.834423-17.885828 0-24.72025zm-122.874183 41.442772-29.082647-29.082647 29.082647-29.082647 29.082647 29.082647z",
    fill: "#fff"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250.579492 115.781385-110.164027-110.16402678c-6.812775-6.81277537-17.829178-6.81277537-24.641954 0l-110.16402679 110.16402678c-6.81277537 6.812776-6.81277537 17.829179 0 24.641954l110.16402679 110.164027c6.812776 6.812776 17.829179 6.812776 24.641954 0l110.164027-110.164027c6.812776-6.812775 6.812776-17.829178 0-24.641954zm-122.485004 41.311511-28.9905333-28.990534 28.9905333-28.9905333 28.990534 28.9905333z",
    fill: "#fff"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250.579492 115.781385-110.164027-110.16402678c-6.812775-6.81277537-17.829178-6.81277537-24.641954 0l-110.16402679 110.16402678c-6.81277537 6.812776-6.81277537 17.829179 0 24.641954l110.16402679 110.164027c6.812776 6.812776 17.829179 6.812776 24.641954 0l110.164027-110.164027c6.812776-6.812775 6.812776-17.829178 0-24.641954zm-122.485004 41.311511-28.9905333-28.990534 28.9905333-28.9905333 28.990534 28.9905333z",
    fill: "#fff"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250.579492 115.781385-110.164027-110.16402678c-6.812775-6.81277537-17.829178-6.81277537-24.641954 0l-110.16402679 110.16402678c-6.81277537 6.812776-6.81277537 17.829179 0 24.641954l110.16402679 110.164027c6.812776 6.812776 17.829179 6.812776 24.641954 0l110.164027-110.164027c6.812776-6.812775 6.812776-17.829178 0-24.641954zm-122.485004 41.311511-28.9905333-28.990534 28.9905333-28.9905333 28.990534 28.9905333z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250.579492 115.781385-40.586747-40.5867464-28.990533-28.9905335-52.907724 52.9077236 28.990534 28.9905333-28.990534 28.990534-52.9077234 52.907723 40.5867464 40.586747c6.812776 6.812776 17.829179 6.812776 24.641954 0l40.586747-40.586747 28.990533-28.990533 40.586747-40.586747c6.812776-6.812775 6.812776-17.829178 0-24.641954z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.002212 46.2041051-40.586747-40.58674688c-6.812775-6.81277537-17.829178-6.81277537-24.641954 0l-40.5867464 40.58674688-28.9905335 28.9905335-40.58674689 40.5867464c-6.81277537 6.812776-6.81277537 17.829179 0 24.641954l40.58674689 40.586747 28.9905335 28.990533 52.9077234-52.907723-28.9905333-28.990534 28.9905333-28.9905333z",
    fill: "#4fc3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.773511 7.0668849c6.812776-6.81277537 17.829179-6.81277537 24.641954 0l110.164027 110.1640271c3.188959 3.188959 4.928391 7.392586 5.073344 11.596214.144952-4.638486-1.449527-9.421924-5.073344-13.045741l-110.164027-110.16402678c-6.812775-6.81277537-17.829178-6.81277537-24.641954 0l-110.16402679 110.16402678c-3.62381669 3.623817-5.21829603 8.407255-5.07334336 13.045741.14495267-4.203628 1.88438467-8.407255 5.07334336-11.596214z",
    fill: "#fff",
    mask: "url(#g)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.579492 138.973812-110.164027 110.164028c-6.812775 6.812775-17.829178 6.812775-24.641954 0l-110.16402679-110.164028c-3.18895869-3.188958-4.92839069-7.392586-5.07334336-11.596213-.14495267 4.638485 1.44952667 9.421923 5.07334336 13.04574l110.16402679 110.164027c6.812776 6.812776 17.829179 6.812776 24.641954 0l110.164027-110.164027c3.623817-3.623817 5.218296-8.262302 5.073344-13.04574-.144953 4.203627-1.884385 8.407255-5.073344 11.596213z",
    fill: "#1a237e",
    mask: "url(#h)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.094488 157.092896-52.9077234 52.907723 40.5867464 40.586747c6.812776 6.812776 17.829179 6.812776 24.641954 0l40.586747-40.586747z",
    fill: "url(#a)",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.579492 115.781385-110.164027-110.16402678c-6.812775-6.81277537-17.829178-6.81277537-24.641954 0l-110.16402679 110.16402678c-6.81277537 6.812776-6.81277537 17.829179 0 24.641954l110.16402679 110.164027c6.812776 6.812776 17.829179 6.812776 24.641954 0l110.164027-110.164027c6.812776-6.812775 6.812776-17.829178 0-24.641954zm-122.485004 41.311511-28.9905333-28.990534 28.9905333-28.9905333 28.990534 28.9905333z",
    fill: "url(#b)",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-11.060073-11.052199h278.309121v278.309121h-278.309121z",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128.581969 157.330709 22.25618 22.223976-54.8615764 50.97528-20.2915332-20.292524z",
    fill: "url(#d)",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.991418 46.4645669 22.25618 22.223976-54.861577 50.9752811-20.291533-20.2925243z",
    fill: "url(#e)",
    mask: "url(#i)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTagManager);
export default __webpack_public_path__ + "static/media/google-tag-manager.8929439579fa488b40d3ff0682dd8ab7.svg";
export { ForwardRef as ReactComponent };